import { Box } from 'components/ui';
import { Row, Col } from 'react-grid-system';
import { Link } from 'react-router-dom';
import { futuraContractAddress } from 'utils/config';
import { getOpenSeaUrl } from 'utils/networks';
import { OwnedNft } from 'utils/types';
import { DROP } from './common';
import { DROP_CONFIG } from './Drops/dropConfig';

interface EBCollectionListProps {
  owned: OwnedNft[];
}

const getUrl = (chain: number, contractAddress: string, tokenId: string) => {
  if (contractAddress === futuraContractAddress) {
    return `/futura/details/${tokenId}`;
  }
  if (contractAddress === DROP_CONFIG[DROP.genesis].contractAddress) {
    return `/genesis/${tokenId}`;
  }
  if (contractAddress === DROP_CONFIG[DROP.enigma].contractAddress) {
    return `/enigma/${tokenId}`;
  }

  return getOpenSeaUrl(chain, contractAddress, tokenId);
};

const getTarget = (contractAddress: string) => {
  if (
    contractAddress === futuraContractAddress ||
    contractAddress === DROP_CONFIG[DROP.genesis].contractAddress ||
    contractAddress === DROP_CONFIG[DROP.enigma].contractAddress
  ) {
    return '_self';
  }
  return '_blank';
};

const EBCollectionList = ({ owned }: EBCollectionListProps) => {
  if (!owned || owned.length === 0) {
    return <Box my={3}>You don't have any items in your collection.</Box>;
  }

  return (
    <Row>
      {owned.map(nft => {
        return (
          <Col key={nft.contract_address + nft.token_id} sm={12} md={6} lg={4} xl={3} xxl={2}>
            <Link
              to={{ pathname: getUrl(nft.chain, nft.contract_address, nft.token_id) }}
              target={getTarget(nft.contract_address)}
            >
              <Box margin={2} width={[140, 180]}>
                {nft.metadata?.image ? (
                  <Box
                    width="100%"
                    height={[140, 180]}
                    backgroundImage={`url(${nft.metadata?.image})`}
                    backgroundSize="cover"
                    border="4px solid #222"
                  />
                ) : (
                  <Box width="100%" height={[140, 180]} border="4px solid #222" bg="#444" />
                )}

                <Box width="100%" textAlign="center" fontSize={['12px', '16px']} mt={2} mb={2}>
                  {nft.metadata?.name}
                  {parseInt(nft.quantity, 10) > 1 && ` (${nft.quantity})`}
                </Box>
              </Box>
            </Link>
          </Col>
        );
      })}
    </Row>
  );
};

export default EBCollectionList;
